<script>
    import Axios from 'axios'
    import config from '../../../libs/config.js';
    import api from '../../../api'
    import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
    import _system from '../../../libs/system'	

    import { removeChannel } from '../mixins/removeChannel'

    import iziToast from 'izitoast'
    import 'izitoast/dist/css/iziToast.min.css';

	export default 
	{
        name: 'accountsWhatsApp',
        mixins: [removeChannel],        
        data() 
        {
        	return {
                config: config,
                appUrl: '',
                showEditPageName: false,
                pages: [],
                modals: {
                    upload: true
                },
                form: {
                    accountSid: '',
                    token: '',
                    phone: ''
                },
                loader: true
        	}
        },
        computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn','getUser', 'getRole','getJwt']),
            ...mapGetters('accounts', ['accounts']),
            ...mapGetters('tags', ['tagsByName']),        
            ...mapGetters('workspaceusers', ['workspaceusers']), 
            ...mapGetters('workspaces', ['currentWorkspace']),
	        ...mapGetters('networks', ['networks','networksByName'])
        },
        methods: {
            ...mapActions('accounts', ['setAccounts', 'removeChannel']),
            ...mapActions('networks', ['setNetworks']),
            reAuth(){
               document.getElementById("auth").submit(); 
            },         
            updateChannelName(account){
                if(account.name.length == 0){ return alert('Input cannot be empty!')}
                let payload = {
                        query: {
                            pageId: account._id
                        },
                        body: {
                            name: account.name
                        }
                    }
                    _system.services.accounts.update(payload, (err, updatedChannel) => {
                        iziToast.success({
                            position: 'bottomCenter',
                            title: 'Saved ✅',
                        });
                    });  
            },   
            update_status(e, pageId){
                if(!e.target.checked) {
                    let payload = {
                        query: {
                            pageId: pageId
                        },
                        body: {
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.setTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });                   
                }else{
                    let payload = {
                        query: {
                            pageId: pageId,
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.deleteTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });
                }

            }              
        },
        mounted(){

         window.Intercom("showArticle", 7873657);

            $('.ui.dropdown').dropdown({
                transition: 'scale'
              })

              window.fbAsyncInit = function () {
                    // JavaScript SDK configuration and setup
                    FB.init({
                    appId:    '220505862059842', // Facebook App ID
                    cookie:   true, // enable cookies
                    xfbml:    true, // parse social plugins on this page
                    version:  'v16.0' //Graph API version
                    });
                };

                // Load the JavaScript SDK asynchronously
                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s); js.id = id;
                    js.src = "https://connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));

                // Facebook Login with JavaScript SDK
                window.launchWhatsAppSignup = () => {

                    /* if(!this.getUser.email.includes('juphy')) return alert('WhatsApp Integration will  be available soon.') */

                    // Conversion tracking code
/*                 fbq && fbq('trackCustom', 'WhatsAppOnboardingStart', 
                    {
                    appId: '220505862059842', 
                    feature: 'whatsapp_embedded_signup',
                    version: 1
                }); */
                    
                    // Launch Facebook login
                    window.FB.login( (response) => {
                    if (response.authResponse) {
                        const accessToken = response.authResponse.accessToken;
                        console.log(accessToken)
                        //Use this token to call the debug_token API and get the shared WABA's ID
                    } else {
                        console.log('User cancelled login or did not fully authorize.');
                    }
                    }, {
                    scope: (this.$route.query.scope && this.$route.query.scope.length) ? this.$route.query.scope : 'business_management,whatsapp_business_management',
                    extras: {
                        feature: "whatsapp_embedded_signup",
                        version: 2
                    }
                    });
                };

        },
        created(){
            //Store Fetching

            //5e317dcfa36c3336dbb20880
            
            if(this.accounts && this.networks){
                this.pages = _.filter(this.accounts, (e) => { return e.platform == this.networksByName['WhatsApp']._id }); 
                console.log('44', this.networks);
                console.log('44', this.accounts);
                console.log('44', this.networksByName['Twilio']);
                this.loader = false;
            }  

            //API Fetching
/*             if(!this.accounts){
                        api.get('/api/v1/platforms', (err, data) => {
                if(err) return console.log(err);
                    this.setNetworks(data);

                api.get('/api/v1/workspaces?user=' + this.getUser._id, (err, data) => {
                    if(err) return console.log(err);
                        this.setAccounts(_.get(data, '[0].pages', []));

                let youtubeId = _.find(this.networks, function(e){ return e.name == 'Youtube' })._id
                this.pages = _.filter(this.accounts, function(e){ return e.platform == youtubeId }); 
                this.pages = _.map(this.pages, page => {
                    if(!page.name) page.name = page.screenName;
                    return page
                })
                this.loader = false;
                });
                });
            } */
        }
	}
</script>

<template>
	<span>

<div v-if="modals.upload " class="modalWrapper">
<div @click="modals.upload = false" class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">
      <div  class="ui grid centered stackable">
        <div style="padding-top:0; padding-bottom:0; padding-right:0;" class="five wide column" >
          <div  @click="modals.upload = false"  class="ui basic segment right aligned">
            <a style="background: rgba(0,0,0,0.6); position:relative; z-index:999999" class="ui black mini button">Close [ESC]</a>
          </div>
        </div>
      </div>
        <div class="ui grid centered stackable">
                <div style="background: rgba(0,0,0,.06);z-index: 9999;border-radius: 10px;" class="five wide column">
                <div style="padding-bottom: 1rem;" class="ui grid">
                <div style="padding-bottom: 0;" class="row">
                <div class="sixteen wide column">
                    <div style="background: #f5f5f5; border-bottom: 1px solid #e9e9e9; border-radius: 3px 3px 0 0;" class="ui basic segment">
                    <div class="ui warning message">
                    <i class="icon help"></i>
                    In order to connect your WhatsApp account, you must complete initial setup requirements first 👉
                    <a href="https://help.juphy.com/en/articles/7873657-adding-your-first-whatsapp-number">https://help.juphy.com/en/articles/7873657-adding-your-first-whatsapp-number</a>
                    </div>
                    <p>If you already finished initial setup, click next button to complete setup.</p>
                    <button @click="reAuth()" class="ui fluid blue button" type="button" >Next</button>
                    </div>
                </div>
                </div>
                </div>
                </div>
            </div>
    </div>
    </div>

    <div style="background: #f5f5f5; margin-bottom: 1rem;" class="ui grid">
        <div class="sixteen wide column">
            
            <!-- <button onclick="launchWhatsAppSignup()" style="background: #11bb19;" type="submit" value="Submit" class="ui green button left floated"><i class="icon whatsapp"></i> Add WhatsApp Number </button> -->

            <form v-if="getRole.name == 'Admin'" id="auth" action="https://graph.facebook.com/oauth/authorize" method="get">

            <input type="text" name="state" :value="JSON.stringify({ 'userId': getUser._id, 'workspaceId': currentWorkspace._id })" hidden>

            <input type="text" name="accessToken" :value="getJwt" hidden>
            <input type="text" name="client_id" :value="'220505862059842'" hidden>

            <input type="text" name="redirect_uri" :value="config.url + '/whatsapp/redirect'" hidden>

            <input type="text" name="response_type" :value="'code'" hidden>

            <input type="text" name="access_type" :value="'offline'" hidden>

            <input type="text" name="prompt" :value="'consent'" hidden>

            <input type="text" name="scope" :value="'whatsapp_business_management, whatsapp_business_messaging'" hidden>

            <button style="background: #11bb19;" type="submit" value="Submit" class="ui green button left floated"><i class="icon whatsapp"></i> Add WhatsApp Number </button>
            </form>

        </div>
        </div>

<!--         <div v-if="!loader && !pages.length" class="ui basic padded segment center aligned">
            <p style="color: #ccc;font-size: 20px;font-style: italic;">
                Don't have any active WhatsApp Business account.
            </p>
        </div> -->

        <table v-if="!loader && pages.length" style="padding: 0rem 0.5rem;" class="ui very basic celled table fluid">
            <tbody>
            
            <tr v-for="account in pages" :key="account._id">
                <td><h4 class="ui image header">
                    <img :src="account.avatar" class="ui mini rounded image">
                    <div class="content">
                        {{account.name}}
                        <div v-if="showEditPageName" style="margin-left: 1rem;" class="ui action input">
                            <input type="text"  v-model="account.name" placeholder="Cannot be empty!">
                            <button class="ui button" @click="updateChannelName(account)">Save</button>
                        </div>
                    </div>
                </h4></td>
<!--                               <td class="collapsing">
                    <a class="ui basic label">#tw-{{account.screenName}}</a>
                </td> -->
                <td class="collapsing" style="vertical-align: bottom;">



                <div  v-if="account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') != -1" class="ui compact warning small message" style="width:400px;">
                        <div class="header">Permissions Expired</div>
                        <p>Juphy can't access data for this channel. To regain data access, you have to re-authorize your account's permissions. Remove this one from the list and re-fill the form above.
                        </p>
                    </div>


<!--                     <div v-if="getRole.name == 'Admin' && (account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') == -1) || (!account.tags)" class="ui fitted toggle checkbox check">
                        
                        <input v-if="account.tags && account.tags.indexOf(tagsByName['Passive']._id) != -1"  @click="update_status($event, account._id)" type="checkbox" :checked="false">
                        <input v-if="!account.tags || account.tags.indexOf(tagsByName['Passive']._id) == -1" @click="update_status($event, account._id)" type="checkbox" :checked="true"> 
                        <label></label>
                        
                    </div> -->
                </td>
            <td class="collapsing">
                <div style="background: transparent;" class="ui left dropdown icon button">
                    <i class="ellipsis vertical icon"></i>
                    <div class="menu">
                        <div @click="(showEditPageName) ? showEditPageName = false : showEditPageName = true" class="item">Edit</div>
                        <div @click="deleteChannel(account._id)" class="item">
                        Delete
                        </div>
                    </div>
                    </div>
                </td>
<!--                               <td class="collapsing">
                    <a :href="'/account/settings/'+ account.id" class="ui basic small icon button more-basic"><i class="cog icon"></i></a>
                </td> -->
            </tr>
            
            </tbody>
        </table> 
	</span>
</template>


<style scoped >


.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.65) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 2px 54px rgba(99, 99, 99, 0.85);
   border: none;
   background: #eee;
}

.ui.table thead th {
    border-bottom: none;
}
.ui.toggle.checkbox input:checked ~ label::before {
    background-color: #8ef2b6 !important;
}
.ui.toggle.checkbox label::before{
    height: 1.9rem;
}
.ui.toggle.checkbox label::after{
    height: 1.9rem;
    width: 1.9rem;
}
.ui.toggle.checkbox input:checked ~ label::after {
    left: 1.6rem;
    box-shadow: 1px 1px 1px #ddd;
}
.ui.toggle.checkbox input {
    height: 1.9rem;
}
.ui.table td.collapsing, .ui.table th.collapsing {
    width: 1px;
    white-space: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/accounts/whatsApp.vue